var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PopUp"},[_vm._t("default"),_c('div',{staticClass:"PopUp-btnContainer"},[_c('button',{staticClass:"PopUp-btn",on:{"click":function($event){return _vm.$emit('shop-error-popUp', false)}}},[_vm._v("OK")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }